// import Vue from 'vue'
import Vue from 'vue';

//import Vue from 'vue/dist/vue.esm.js'
import App from './App.vue'

import VueRouter from 'vue-router'
import ROUTE from './router'

import './assets/css/global.css'

import Vuex from 'vuex'
import STORE from './store/index'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'
import config from './config/index'

import FormItem from './components/FormItem.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Tab from './components/Tab.vue'
import Table from './components/Table.vue'
import SearchField from './components/SearchField.vue'
import Pagination from './components/Pagination.vue'
import RadioGroup from './components/RadioGroup.vue'
import Dialog from './components/Dialog.vue'
import FormItemRemind from './components/FormItemRemind.vue'
import Certificate from './components/Certificate.vue'
import Insurance from './components/Insurance.vue'
import FormDialog from './components/FormDialog.vue'
import Btn from './components/Btn.vue'
import TabMenu from './components/TabMenu.vue'
import RadioMenu from './components/RadioMenu.vue'
import CompositeFormCtrl from './components/CompositeFormCtrl.vue'
import CompositeFormDate from './components/CompositeFormDate.vue'
import SubmitBtn from './components/SubmitBtn.vue'
import CancelBtn from './components/CancelBtn.vue'
import MySwitch from './components/MySwitch.vue'
import MyForm from './components/MyForm.vue'
import Wxts from './components/Wxts.vue'
import VehicleSelect from './components/VehicleSelect.vue'
import VehicleRadio from './components/VehicleRadio.vue'
import ExtraFee from './components/ExtraFee.vue'
import PaymentSwitch from './components/PaymentSwitch.vue'


import * as echarts from 'echarts'

// vue中导出excel表格模板
import FileSaver from 'file-saver'  
import XLSX from 'xlsx'
// 将excel表格模板设置全局
Vue.prototype.$FileSaver = FileSaver; 
Vue.prototype.$XLSX = XLSX; 

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter(ROUTE)

Vue.use(Vuex)

const store = new Vuex.Store(STORE)

Vue.use(ElementUI);

Vue.prototype.get = (path, params, cb, cbe) => {
  let url = `${config.IP}/${config.basePath}/${path}`
  // console.log(url, params)
  let str = ''
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      const s = params[key];
      s ? str += `&${key}=${s}` : null
    }
  }
  // console.log(str)
  if (str && url.includes('?')) {
    url += str
  } else if (str && !url.includes('?')) {
    url += str.replace('&', '?')
  }
  console.log(url)
  axios.get(url)
    .then((res) => {
      cb(JSON.parse(res.data.body))
    }).catch((err) => {
      if (typeof cbe == 'function') {
        cbe(err);
      } else {
        // Error()
        console.log(err)
      }
    });
}
Vue.prototype.post = (path, params, cb, cbe) => {
  const url = `${config.IP}/${config.basePath}/${path}`
  // console.log(url, params)
  axios.post(url, params)
    .then((res) => {
      cb(res.data)
    }).catch((err) => {
      if (typeof cbe == 'function') {
        cbe(err);
      } else {
        // Error()
        console.log(err)
      }
    });
}

axios.defaults.baseURL = `${config.IP}/${config.basePath}/`
Vue.prototype.POST = axios.post
Vue.prototype.GET = axios.get

Vue.component(FormItem.name, FormItem);
Vue.component(Breadcrumb.name, Breadcrumb);
Vue.component(Tab.name, Tab);
Vue.component(Table.name, Table);
Vue.component(SearchField.name, SearchField);
Vue.component(Pagination.name, Pagination);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Dialog.name, Dialog);
Vue.component(FormItemRemind.name, FormItemRemind);
Vue.component(Certificate.name, Certificate);
Vue.component(Insurance.name, Insurance);
Vue.component(FormDialog.name, FormDialog);
Vue.component(Btn.name, Btn);
Vue.component(TabMenu.name, TabMenu);
Vue.component(RadioMenu.name, RadioMenu);
Vue.component(CompositeFormCtrl.name, CompositeFormCtrl);
Vue.component(SubmitBtn.name, SubmitBtn);
Vue.component(CancelBtn.name, CancelBtn);
Vue.component(MySwitch.name, MySwitch);
Vue.component(MyForm.name, MyForm);
Vue.component(Wxts.name, Wxts);
Vue.component('CompositeFormDate', CompositeFormDate);
Vue.component('VehicleSelect', VehicleSelect);
Vue.component('VehicleRadio', VehicleRadio);
Vue.component('ExtraFee', ExtraFee);
Vue.component('PaymentSwitch', PaymentSwitch);

Object.assign(Vue.prototype, config)

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
